<template>
  <section class="section">
    <div class="container columns is-gapless has-background-white">
      <div  class="column is-6 card-block left-block is-flex">

        <!-- Written by -->
        <div class="card-content written-by">
          <div class="footer-title has-text-weight-semibold">WRITTEN BY</div>
            <div class="owner">
              <span class="icon"><img :src="avatar" :alt="username" class="has-background-grey-lighter"></span>
              <span class="owner-name has-text-weight-bold has-text-dark cursor-pointer" @click="viewProfile(username)"> {{fullname}}
                <span v-if="isEngStaff" class="staff-shield"><i class="fal fa-shield-check"></i></span>
              </span>
              <span v-if="showFollowButton" class="button is-small is-rounded gtm-follow-storyauthor" :class="{'following has-text-white has-background-primary':followingUser, 'is-outline follow':!followingUser}" @click="toggleConnection">
                  {{label}} <i v-if="clickedConnect" class="fal fa-circle-notch fa-spin gtm-follow-storyauthor"></i>
              </span>
            </div>
          <div class="is-size-7 bio"><html-view ref="htmlView" :content="bio"></html-view></div>
        </div>

        <!-- See more like this -->
        <div class="card-content">
          <div class="footer-title has-text-weight-bold see-more">{{ $t('story-footer.related') }}</div>
          <project-categories class="project-categories is-inline-block gtm-footer-more-like" :project="this.project"></project-categories>
          <project-tags class="project-tags" :project="this.project"></project-tags>
        </div>
      </div>

      <!-- See more like this -->
      <div  class="column is-6 card-block">
        <div class="card-content">
          <div class="footer-title has-text-weight-semibold has-text-grey">{{ $t('story-footer.see-more') }}</div>
          <a :href="link._source.link" v-for="link in authorLinks" :key="link._source.id" class="author-link is-flex is-size-6 has-text-weight-bold gtm-footer-more-from">
            {{ link._source.title }}
          </a>
        </div>
      </div>
    </div>

    <!-- Personalize -->
    <div class="personalize is-flex no-print">
      <personalize-button type="cta-button" class="gtm-footer-personalize-feed" @click="personalizeFeed('story-footer')">{{ $t('story-footer.personalize-feed') }}</personalize-button>
      <div class="tagline has-text-centered-mobile">{{ $t('story-footer.curate') }}</div>
    </div>

    <categories-modal ref="categoryModal"></categories-modal>

    <modal-custom v-if="showDisconnectModal" :title="'Unfollow'" :text="'Are you sure you want to unfollow this user?'"
    :hasFooter="true" :successText="'Unfollow'" :cancelText="'Cancel'"
    @modalSuccess="confirmDisconnect" @modalCancel="showDisconnectModal = false"></modal-custom>
  </section>
</template>

<script>
import throttle from 'lodash/throttle'
import ModalCustom from '@/components/Modals/Custom'
import auth from '@/mixins/auth'
import CategoriesModal from '@/components/Modals/Categories'
import imageProxy from '@/libs/image-proxy'
import ProjectCategories from '@/components/SectionProjectView/Header/ProjectCategories'
import ProjectTags from './Header/ProjectTags'
import trending from './trending'
import PersonalizeButton from '@/components/Controls/ButtonTemplate'
import HtmlView from '@/components/Controls/HTMLView'
import ProjectCard from '@/components/Cards/ProjectCards'
import Recommended from './StoryFooter/Recommended'

export default {
  data: function () {
    return {
      clickedConnect: false,
      followingUser: false,
      showDisconnectModal: false,
      showRecommended: false,
      message: '',
      bio: '',
      authorLinks: []
    }
  },
  mixins: [auth, trending],
  components: {
    HtmlView,
    ModalCustom,
    ProjectCategories,
    ProjectTags,
    CategoriesModal,
    PersonalizeButton,
    ProjectCard,
    Recommended
  },
  props: ['project'],
  mounted: function () {
    this.checkConnection()
    this.getAuthorLinks()
  },
  created: function () {
    this.fetchBio()
  },
  updated: function () {
    this.checkConnection()
  },
  computed: {
    label: function () {
      return !this.followingUser ? 'Follow' : 'Following'
    },
    user: function () {
      return this.project && this.project.user ? this.project.user : null
    },
    username: function () {
      return this.user ? this.user.userName : ''
    },
    fullname: function () {
      return this.project.user && this.project.user.fullName.length ? this.project.user.fullName : ''
    },
    avatar: function () {
      return this.user ? imageProxy.thumbnail(this.user.avatar) : ''
    },
    isEngStaff: function () {
      return this.user ? this.user.isEngStaff : ''
    },
    showFollowButton: function () {
      return !this.isLoggedIn || (this.user && this.user.uuid !== this.currentUser.uuid)
    }
  },
  methods: {
    personalizeFeed: function (source) {
      this.$refs.categoryModal.showModal(source)
    },
    toggleRecommended: function () {
      this.showRecommended = !this.showRecommended
    },
    checkConnection: function () {
      if (this.isLoggedIn) {
        this.$store.dispatch('checkForUserConnection', { username: this.currentUser.userName, otherUsername: this.username }).then((following) => {
          this.followingUser = following
        }, (error) => {
          this.error = error.message
        })
      }
    },
    viewProfile: function () {
      this.$router.push({ name: 'profile', params: { username: this.username } })
    },
    fetchBio: function () {
      this.$store.dispatch('getProfile', this.username).then((user) => {
        this.bio = user.intro || user.bio
      })
    },
    toggleConnection: function () {
      if (this.followingUser) {
        return this.disconnect()
      }
      this.connect()
    },
    connect: throttle(function () {
      if (!this.isLoggedIn) {
        return this.$store.dispatch('showLoginModal', { source: 'CONNECT:{PATH}', onSuccess: this.connect, signupMessage: 'Sign up to follow ' + this.fullname })
      }
      this.clickedConnect = true
      this.error = ''

      this.$store.dispatch('connectToUser', { username: this.currentUser.userName, otherUsername: this.username }).then((response) => {
        this.clickedConnect = false
        this.followingUser = true
      }, (error) => {
        this.error = error.message
        this.clickedConnect = false
      })
    }, 500, { leading: true, trailing: false }),
    disconnect: function () {
      this.showDisconnectModal = true
    },
    confirmDisconnect: throttle(function () {
      this.showDisconnectModal = false
      this.clickedConnect = true
      this.error = ''
      this.$store.dispatch('disconnectFromUser', { username: this.$store.getters.currentUser.userName, otherUsername: this.username }).then((response) => {
        this.clickedConnect = false
        this.message = `You have unfollowed ${this.username}`
        this.followingUser = false
      }, (error) => {
        this.clickedConnect = false
        this.error = error.message
      })
    }, 500, { leading: true, trailing: false }),
    getAuthorLinks: async function () {
      try {
        await fetch(`https://sm5whnocrb.execute-api.us-east-1.amazonaws.com/EngSearch?title=${this.project.title}&size=5`)
          .then(response => response.json())
          .then(data => data.hits.hits.forEach(item => {
            this.authorLinks.push(item)
          }))
        return this.authorLinks
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

.project-categories {
  margin-bottom: 0.25rem;
  width: 95%
}
.bio {
  padding: 0.5rem 0;
}

.left-block {
  flex-direction: column;
  justify-content: space-between;
}

.card-content {
  padding: 0;
  padding-left: 1rem;
  @include mobile {
    padding: 1rem;
  }
}

.section{
  background-color: white;
  padding: 1rem 0;
  .container {
    max-width: 700px; // controls the width of all components
    margin: 0 auto;
    padding: 2rem;
    @include mobile {
      padding: 0;
    }
  }
}

.written-by {
  margin-bottom: 1rem;
  margin-right: 0.5rem;
  @include mobile {
    margin: 0;
  }
}

.see-more {
  margin-bottom: 0.5rem;
}

.footer-title {
  font-size: 0.6rem;
  color:#7A2A90;
}

.icon {
  width: 1.7rem;
  height: 1.7rem;
  margin-right: 0.25rem;
  margin-bottom: 0.5rem;
  img {
    border-radius: 50%;
    border: 1px solid whitesmoke;
    height: 100%;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
  }
}
.owner {
  margin-top: 0.5rem;
  .owner-name {
    font-size: 1.1rem;
    line-height: 1.6;
    vertical-align: top;
  }
  .staff-shield {
    vertical-align: top;
    margin-right: 0.2rem;
    i {
      padding-top: 0.45rem;
      vertical-align: top;
      @include mobile {
        padding-top: 0.55rem;
      }
    }
  }
}
.follow {
  padding: 0.5rem;
  box-shadow: 0px 4px 4px -4px rgba(0,0,0,0.5);
}
.fa-circle-notch {
  margin-left: 0.25rem;
}

.following {
  margin-left: 0.5rem;
  border-color: $primary;
  box-shadow: 0px 4px 4px -4px rgba(0,0,0,0.5);
  transition: background 0.35s;
}

.author-link {
  font-family: 'Noto Serif JP, Serif';
  padding: 0.75rem 0;
  border-bottom: 1px solid $grey-lighter;
  color: $dark;
}

.author-link:last-child {
  border-bottom: none;
}

.recommended {
  .header {
    font-size: 0.7rem;
    margin-bottom: 1rem;
  }
}

.reco-link {
  margin: 0.5rem 0;
  align-items: center;

  .image {
    height: 4rem;
    min-height: 4rem;
    width: 8rem;
    min-width: 8rem;
    background-position: center;
    background-size: cover;
  }

  .reco-title {
    font-family: 'Noto Serif JP, Serif';
    margin-left: 1rem;
    width: 90%;
    color: $dark;
    margin-right: 0.35rem;
  }

  .reco-author {
    font-family: Roboto;
    white-space: nowrap;
  }
}

.author-link:hover, .reco-link, .reco-title:hover {
  color: $primary;
}

.personalize {
  justify-content: center;
  margin: 1rem;
  padding: 1rem;
  max-width: 700px; // controls the width of all components
  margin: 0 auto;
  @include mobile {
    flex-direction: column;
  }
  .tagline {
    width: 40%;
    font-size: 0.8rem;
    margin-left: 1rem;
    @include mobile {
      width: 100%;
      margin: 1rem 0 0;
    }
  }
}

.card-row {
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 0.8rem;
  width: 99%;
}

</style>
